module.exports = __webpack_public_path__ + "img/img_admin.44842439.png";